export const routes = {
	category: "/",
	test: "/test",
	test2: "/test2",
	cart: "/cart",
	productDt: "/product-detail/:productId",
};
